import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { Provider } from "react-redux";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import store from "../redux/store";
import App from "../App";
import Minting from "../pages/minting.page";
import Roadmap from "../pages/roadmap.page";
import Navbar from "../components/navbar.component";
import { ToastContainer } from "react-toastify";
import Footer from "../components/footer.component";

const Routing = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <Router>
      <Provider store={store}>
        <Navbar />
        <ToastContainer
          position="bottom-left"
          autoClose={6000}
          hideProgressBar
          closeOnClick
          theme="dark"
          toastStyle={{
            bottom: 10,
            border: "1px solid rgba(var(--primary-rgb), 0.75)",
            boxShadow:
              "0 0 60px 5px rgba(var(--primary-rgb), 0.2), 0 0 50px 0px rgba(var(--secondary-rgb), 0.6)",
            backgroundImage:
              "linear-gradient(to right, rgba(var(--secondary-rgb), 0.3), rgba(var(--primary-rgb), 0.6)",
            color: "var(--light)",
            borderRadius: 50,
            textAlign: "center",
            fontSize: 16,
          }}
          rtl={false}
          draggable
          pauseOnHover
        />
        <Routes>
          <Route exact path="*" element={<Navigate to="/" />} />
          <Route exact path="/" element={<App />} />
          <Route path="/mint" element={<Minting />} />
          <Route path="/roadmap" element={<Roadmap />} />
        </Routes>
        <Footer />
      </Provider>
    </Router>
  );
};

export default Routing;
